export default function calculatePrice(product, discount) {
  const { sale_price, price, current_price, quantity } = product;
  // Öncelik sırası: current_price (validated) > sale_price > price
  const basePrice = parseFloat(current_price || sale_price || price) || 0;
  const qty = parseInt(quantity) || 1;

  if (discount) {
    if (discount.type === "percent") {
      // Yüzde indirim: (fiyat * (1 - %indirim)) * miktar
      const discountedPrice = basePrice * (1 - discount.discount / 100);
      return parseFloat(discountedPrice * qty).toFixed(2);
    } else {
      // Sabit indirim: (fiyat - indirim) * miktar
      // NOT: Negatif fiyat kontrolü
      const discountedPrice = Math.max(0, basePrice - discount.discount);
      return parseFloat(discountedPrice * qty).toFixed(2);
    }
  } else {
    return parseFloat(basePrice * qty).toFixed(2);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/calculatePrice.js